<!--
 * @Version      : V1.0
 * @Date         : 2025-05-21 13:27:18
 * @fileName     : 
 * @Description  : 我的开票详情
-->
<template>
  <el-drawer :title="title" v-loading="loading" :visible.sync="dialogDrawer" direction="rtl" :wrapperClosable="false"
    size="80%" :before-close="closeDrawer">
    <div class="details px-20 py-20 border-box">
      <el-row :gutter="20">
        <el-col :span="18">
          <descriptions v-if="!showDesc" :span="6" :status="status" :row-data="rowData" :rules="rules"
            :columns="columns" ref="descriptionsRef">

            <template #contractReceivePaymentSlot="{ data }">
              <div class="flex items-center">
                <div>

                  <!--收款合同 -->

                  <el-select clearable v-model="contractReceivePaymentId" :disabled="data.disabled" filterable remote
                    reserve-keyword placeholder="请选择合同名称"
                    :remote-method="(e) => remoteMethod(e, 'contractReceivePaymentId')" :loading="selectLoading">
                    <el-option v-for="item in receivableContractOption" :key="item.id" :label="item.contractName"
                      @click.native="curOption(item, data, 'contractReceivePaymentId')" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <el-button type="text" @click="openViewProject(contractReceivePaymentId, '2')"
                  v-if="contractReceivePaymentId">查看</el-button>
              </div>
            </template>
            <template #invoicePlanList>
              <InvoicePlanList
                v-model="invoicePlanListData"
                mode="invoice"
                :upload-mode="true"
                :status="status"
              />
            </template>
          </descriptions>
        </el-col>
        <el-col :span="6">
          <div class="approval-progress">
            <div class="progress-box"  v-if="status !== 'add'">
              <div class="progress-title">审批流程</div>
              <div class="progress-desc-info flex flex-wrap">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item v-for="(item, index) in processDescInfo" :key="index">
                    <div class="items">
                      <el-avatar shape="square" size="large"
                          :src="item ? imageUrlprefix + item : defaultAvatar"></el-avatar>
                    </div>
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </div>
            <div class="progress-title" v-if="status !== 'add'">审批进度</div>
            <div class="progress-con" v-if="status !== 'add'">
              <el-timeline>
                <el-timeline-item v-for="(item, index) in processList" :key="index" size="large"
                  :icon="auditProcessStatus(item.auditStatus).icon" :color="auditProcessStatus(item.auditStatus).color">
                  <el-row :gutter="15">
                    <el-col :span="6">
                      <div>
                        <el-image v-if="item.typeLabel == '抄送人'" style="width: 40px;height: 40px;"
                          :src="require('@/assets/makeACopyFor.png')" fit="cover"></el-image>
                        <el-avatar shape="square" v-else size="large"
                          :src="item.avatar ? imageUrlprefix + item.avatar : defaultAvatar"></el-avatar>
                      </div>
                    </el-col>
                    <el-col :span="18" v-if="item.typeLabel == '抄送人'">
                      <div class="makeACopyFor-desc">
                        <div class="makeACopyFor-title">
                          {{ item.typeLabel }}
                        </div>
                        <div class="makeACopyFor-num">
                          已抄送{{ item.userList ? item.userList.length : 0 }}人
                        </div>
                        <div class="makeACopyFor-box flex justify-start items-center flex-wrap">
                          <div class="child-items" v-for="(cItem, cIndex) in item.userList" :key="cIndex">
                            <el-avatar shape="square" size="large"
                              :src="cItem.userAvatar ? imageUrlprefix + cItem.userAvatar : defaultAvatar"></el-avatar>
                            <div class="child-text">{{ cItem.userName }}</div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="18" v-else>
                      <div class="progress-desc">
                        <div><span>{{ item.name }}</span><span class="progress-time">{{ item.date }}</span></div>
                        <div>{{ item.typeLabel }}</div>
                        <div :style="{ color: auditProcessStatus(item.auditStatus).color, fontSize: '18px' }">{{
                          item.auditLabel }}</div>
                        <div class="signature-box flex justify-start items-center" v-if="item.signatureUrl">
                          <span class="signature-title">签名</span>
                          <el-image class="signature-img" :src="imageUrlprefix + item.signatureUrl"
                            fit="contain"></el-image>
                        </div>
                        <el-tooltip class="item" effect="dark" :content="item.auditComment" placement="top-start">
                          <p class="notes-text" v-if="item.auditStatus == 2 || item.auditStatus == 9">
                            {{ item.auditComment }}
                          </p>
                        </el-tooltip>
                      </div>
                    </el-col>
                  </el-row>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="details-footer px-20 py-20 border-box" v-if="status !== 'view'">
      <el-button type="primary" @click="submit()">提交</el-button>
      <el-button @click="clearForm()">清空</el-button>
    </div>
    <view-other-details ref="viewProjectRef"></view-other-details>
  </el-drawer>
</template>

<script>
import descriptions from '@/components/descriptions/index.vue'
import { queryFinReceivedInvoiceDetailsApi, addFinReceivedInvoiceApi, uploadUploadInvoiceApi, processFinReceivedInvoiceApi, queryAuditProcessDescriptionApi } from '@/api/finReceivedInvoiceItem/index'
import { queryBasicOwnersListApi } from '@/api/basicInfo/index'
import { queryPageForLedgerListApi } from '@/api/receivableContract‌/index'
import { getContractInvoiceAndReceivedDataApi } from '@/api/paymentContract/index'
import { auditProcessStatus } from '@/utils/index'
import { dataPage } from "@/api/sys/dictData";
import viewOtherDetails from "@/components/viewOtherDetails/index.vue"
import InvoicePlanList from "./InvoicePlanList.vue"
export default {
  components: {
    descriptions,
    viewOtherDetails,
    InvoicePlanList
  },
  props: {
    title: {
      type: String,
      default: '开票详情'
    },
    status: {
      type: String,
      default: 'view'
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value && /^1[3456789]\d{9}$/.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的手机号码'))
      }
    }
    return {
      defaultAvatar: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
      dialogDrawer: false,
      contractReceivePaymentId: "",
      correlationType: '1',
      selectLoading: false,
      loading: false,
      customerForm: {},
      showDesc: false,
      columns: [
        { key: 'contractReceivePaymentId', label: '关联合同', span: 6, placeholder: '请选择关联合同', disabled: true, defaultValue: '', slotName: 'contractReceivePaymentSlot' },
        {
          key: 'relatedItemsReceivePayment', height: 'auto', label: '关联项收款情况', span: 6, placeholder: '', disabled: true, input: 'table', isShowAdd: false,
          columns: [
            { label: '总金额(元)', key: 'totalAmount', width: '120px', align: 'center', placeholder: '请输入阶段', input: 'input', required: true, defaultValue: "" },
            { label: '已开票金额(元)', key: 'invoicedAmount', width: '120px', placeholder: '请输入预计金额', align: 'center', input: 'input', defaultValue: "" },
            { label: '未开票金额(元)', key: 'noInvoicedAmount', width: '120px', placeholder: '请输入预计日期', align: 'center', input: 'date', defaultValue: "" },
            { label: '已收款金额(元)', key: 'receivedAmount', width: '120px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "" },
            { label: '未收款金额(元)', key: 'noReceivedAmount', width: '120px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "" },
          ],
          defaultValue: []
        },
        {
          key: 'invoicePlanList', height: 'auto', label: '分批次开票计划', span: 6, placeholder: '', disabled: true, input: 'slot', isShowAdd: false,
        },
        { key: 'invoiceOwnerUnitId', label: '开票单位', span: 6, placeholder: '请选择开票单位', input: 'select', type: 'text', disabled: true, defaultValue: '', option: [], labelKey: 'unitName', valueKey: 'id' },
        { key: 'invoiceDate', label: '开票日期', span: 3, placeholder: '请选择开票日期', input: 'date', type: '', disabled: true, defaultValue: '' },
        { key: 'invoiceReserveDays', label: '预留开票时长(天)', span: 3, placeholder: '预留开票时长', input: 'input-number', type: 'text', disabled: true, defaultValue: '' },
        // { key: 'documentCount', label: '文件数量', span: 3, placeholder: '请输入文件数量', input: 'input-number', type: 'text', disabled: true, defaultValue: '' },
        { key: 'invoiceTypeCode', label: '开票类型', span: 6, placeholder: '请选择开票类型', input: 'select', type: 'text', disabled: true, defaultValue: '', option: [], labelKey: 'dictLabel', valueKey: 'dictValue' },

        {
          key: 'receivedInvoiceItemList', height: 'auto', label: '开票明细', span: 6, placeholder: '', disabled: true, input: 'table', isShowAdd: true,
          columns: [
            { label: '名称', key: 'name', width: '120px', align: 'center', placeholder: '请输入名称', input: 'input', required: true, defaultValue: "", required: true, },
            { label: '数量', key: 'count', width: '120px', placeholder: '请输入数量', align: 'center', input: 'input', defaultValue: "", required: true, },
            { label: '单价', key: 'unitPrice', width: '180px', placeholder: '请输入单价', align: 'center', input: 'input', defaultValue: "", required: true, },
            { label: '小计', key: 'totalAmount', width: '120px', align: 'center', placeholder: '请输入小计', input: 'input', defaultValue: "" },
            { label: '备注', key: 'note', width: '120px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "" },
          ],
          defaultValue: []
        },
        { key: 'totalAmount', label: '合计金额(元)', span: 6, placeholder: '请输入合计金额', input: 'input-number', type: 'text', disabled: true, defaultValue: '' },
        { key: 'valueAddedTaxTaxpayerName', label: '增值税纳税人名称', span: 2, placeholder: '请输入增值税纳税人名称', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'taxpayerIdentificationNumber', label: '纳税人识别号', span: 2, placeholder: '请输入纳税人识别号', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'invoiceAddress', label: '开票地址', span: 2, placeholder: '请输入开票地址', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'invoiceBank', label: '开户银行', span: 2, placeholder: '请输入开户银行', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'invoiceBankAccount', label: '银行账号', span: 2, placeholder: '请输入银行账号', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'invoicePhone', label: '电话', span: 2, placeholder: '请输入电话', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'uploadInvoiceUrl', height: '450px', label: '发票上传', span: 6, placeholder: '请上传发票', uploadType: 'project', input: 'upload', fileMaxSize: 20, disabled: true, defaultValue: [], accept: '.xls,.xlsx,.pdf,.doc,.docx,.txt,.bmp,.jpg,.jpeg,.png,.tif,.gif,.svg,.webp,.zip,.rar,.7z', limit: 50, },
        { key: 'attachment', height: '450px', label: '附件', span: 6, placeholder: '请上传附件上传', uploadType: 'project', input: 'upload', fileMaxSize: 20, disabled: true, defaultValue: [], accept: '.xls,.xlsx,.pdf,.doc,.docx,.txt,.bmp,.jpg,.jpeg,.png,.tif,.gif,.svg,.webp,.zip,.rar,.7z', limit: 50, },
        { key: 'notes', label: '备注', span: 6, placeholder: '请输入备注', input: 'textarea', type: 'textarea', disabled: true, defaultValue: '' },
      ],
      rowData: {},
      cloneColumns: [],//复制一遍
      rules: {
        invoiceOwnerUnitId: [
          { required: true, message: '请选择开票单位', trigger: 'change' },
        ],
        invoiceReserveDays: [
          { required: true, message: '请输入预留开票时长', trigger: 'blur' },
        ],
        invoiceTypeCode: [
          { required: true, message: '请选择开票类型', trigger: 'change' }
        ],
        valueAddedTaxTaxpayerName: [
          { required: true, message: '请输入增值税纳税人名称', trigger: 'blur' },
        ],
        taxpayerIdentificationNumber: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' }
        ],
        invoiceAddress: [
          { required: true, message: '请输入开票地址', trigger: 'blur' }
        ],
        invoiceBank: [
          { required: true, message: '请输入开户银行', trigger: 'blur' }
        ],
        invoiceBankAccount: [
          { required: true, message: '请输入银行账号', trigger: 'blur' }
        ],
        invoicePhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ]
      },
      processList: [],
      processDescInfo: [],
      receivableContractOption: [],
      invoicePlanListData: []
    }
  },
  mounted() {
    this.dictOption('invoice_type');
    this.getOwnersList();
    this.getLedgerContractList();
    this.cloneColumns = JSON.parse(JSON.stringify(this.columns))

  },
  methods: {
    auditProcessStatus,
    //核心方法 判断是否是新增 还是编辑  
    async openDrawer(row) {
      this.dialogDrawer = true;
      this.$nextTick(() => {
        switch (this.status) {
          case 'view':
            this.queryDetails({ id: row.id })
            break;
          case 'edit':
            this.queryDetails({ id: row.id })
            break;
          default:
            break;
        }
      })
    },
    //关闭弹框
    closeDrawer() {
      this.dialogDrawer = false;
      this.contractReceivePaymentId = "";
      this.correlationType = '1';
      this.invoicePlanListData = [];
    },
    //详情查询
    queryDetails(params) {
      this.loading = true;
      this.showDesc = true;
      queryFinReceivedInvoiceDetailsApi(params).then(res => {
        this.loading = false;
        this.showDesc = false;
        if (res.code == 200) {
          this.rowData = res.data;
          this.invoicePlanListData = res.data.finReceivedInvoicePlanDtoList || []
          if (this.status !== 'add') {
            this.contractReceivePaymentId = res.data.contractReceivePaymentId;
            this.correlationType = res.data.correlationType;
            for (let i = 0; i < this.columns.length; i++) {
              if (this.columns[i].key == 'uploadInvoiceUrl' && this.status == 'edit') {
                this.columns[i].disabled = false
              } else {
                this.columns[i].disabled = true;
              }

              if (this.columns[i].key == 'relatedItemsReceivePayment') {
                this.reverseDisplayList({ id: res.data.contractReceivePaymentId }, 'contractReceivePaymentId')
              } else {
                this.columns[i].defaultValue = this.rowData[this.columns[i].key];
              }

            }
          }


        }
      }).catch(err => {
        this.loading = false;
      })
      this.queryProcessProject(params)
      this.qeuryAuditProcessDescription(params)
    },
    //提交
    submit(status = 1) {
      this.$refs.descriptionsRef.submit().then((formData = {}) => {
        if ('relatedItemsReceivePayment' in formData) {
          delete formData.relatedItemsReceivePayment
        }
        // 取各批次“开票日期”中最晚的一个回写父级，保证列表/台账单日期展示不缺失
        const planDates = (this.invoicePlanListData || []).map(p => p.invoiceDate).filter(Boolean).sort()
        let params = {
          id: formData.id,
          uploadInvoiceUrl: formData.uploadInvoiceUrl,
          invoiceDate: formData.invoiceDate || (planDates.length ? planDates[planDates.length - 1] : ''),
          finReceivedInvoicePlanDtoList: this.invoicePlanListData || []
        }
        this.loading = true;
        if (this.status == 'edit') {
          uploadUploadInvoiceApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        }
      })
    },
    //清空描述组件form
    clearForm() {
      this.$refs.descriptionsRef.resetForm()
    },
    //查询列表
    queryData() {
      this.$emit('initQueryData')
    },
    async dictOption(type) {
      let params = {
        query: {
          dictType: type
        }
      }
      dataPage(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'invoiceTypeCode' && type == 'invoice_type') {
              item.option = res.data.rows || []
            }
            return item
          })
        }
      })
    },
    //开票单位
    getOwnersList() {
      let params = {
        unitName: ""
      }
      queryBasicOwnersListApi(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'invoiceOwnerUnitId') {
              item.option = res.data || []
            }
            return item
          })
        }
      })
    },
    //查询收款合同台账
    getLedgerContractList(v = '') {
      let params = {
        params: {
          contractName: "",
        }
      }
      this.selectLoading = true;
      queryPageForLedgerListApi(params).then(res => {
        this.selectLoading = false;
        if (res.code == 200) {
          this.receivableContractOption = res.data;
        }
      })
    },
    // 通过合同-获取开票和收款数据
    getInvoiceAndReceivedDataContract(id) {
      let params = {
        id,
      }
      getContractInvoiceAndReceivedDataApi(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'relatedItemsReceivePayment') {
              item.defaultValue = res.data ? [res.data] : [] || []
            }
            return item
          })
        }
      })
    },
    remoteMethod(query, current = '') {
      if (query !== '') {
        switch (current) {
          case 'contractReceivePaymentId':
            this.getLedgerContractList(query)
            break;
          default:
            break;
        }
      } else {
        this.projectOptions = [];
        this.receivableContractOption = [];
      }
    },
    //审批进度
    queryProcessProject(params) {
      processFinReceivedInvoiceApi(params).then(res => {
        if (res.code == 200) {
          this.processList = res.data;
        }
      })
    },
    qeuryAuditProcessDescription(params) {
      queryAuditProcessDescriptionApi(params).then(res => {
        if (res.code == 200) {
          this.processDescInfo = res.data.avatars;
        }
      })
    },
    //下拉当前选中
    curOption(v = {}, slotData, current) {
      let item = v;
      if (this.status == 'add' || this.status == 'edit' || this.status == 'change') {
        for (let i = 0; i < this.columns.length; i++) {
          for (let key in item) {
            if (this.columns[i].key == key && !this.columns[i].slotName) {
              this.columns[i].disabled = false;
              // if(this.columns[i].key == 'receivePaymentPlanList'){
              //   console.log(item,'v')
              //   this.columns[i].defaultValue = item.makePaymentPlanList || [];
              // }
            }
          }
        }
      }
      this.reverseDisplayList(v, current)
    },
    //关联收款情况反显
    reverseDisplayList(data = {}, current) {

      if (current) {
        if (current == 'contractReceivePaymentId' && data.hasOwnProperty('id')) {
          this.getInvoiceAndReceivedDataContract(data.id)
        } else {
          this.columns.map(item => {
            if (item.key == 'relatedItemsReceivePayment') {
              item.defaultValue = [
                {
                  totalAmount: '--',
                  noInvoicedAmount: '--',
                  noReceivedAmount: '--',
                  receivedAmount: '--',
                  invoicedAmount: '--'
                }
              ]
            }
            return item
          })
        }
      }
    },
    openViewProject(id, correlationType) {
      this.$refs.viewProjectRef.viewProject(id, correlationType)
    }
  }
}
</script>

<style scoped lang="scss">
.details-footer {
  height: 50px;
  line-height: 50px;
  text-align: right;
}

.progress-box{
  padding: 5px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  border-radius: 5px;
  margin-bottom: 5px;
  background: #285af1;
  .progress-title {
    font-size: 18px;
    padding-bottom: 10px;
    color: #fff;
  }
  .progress-desc-info {
    padding: 10px 0px 10px 0px;

    .items {
      font-size: 15px;
      display: inline-block;
      vertical-align: middle; 
    }
  }
}
.approval-progress {
  

  .progress-title {
    font-size: 18px;
    padding-bottom: 10px;
  }

  .progress-con {
    .progress-desc {
      line-height: 20px;
      color: #303133;

      .progress-time {
        margin-left: 10px;
        color: #909399;
      }

      .notes-text {
        display: -webkit-box;
        /* 设置为弹性盒子模型 */
        -webkit-box-orient: vertical;
        /* 垂直排列 */
        -webkit-line-clamp: 2;
        /* 显示最多 3 行 */
        overflow: hidden;
        /* 隐藏超出的部分 */
        text-overflow: ellipsis;
        /* 使用省略号 */
      }

      .signature-box {
        width: 180px;
        height: 50px;
        overflow: hidden;

        .signature-title {
          display: block;
          width: 40px;
        }

        .signature-img {
          margin-left: 10px;
          width: 180px;
        }
      }
    }

    .makeACopyFor-desc {
      line-height: 20px;
      color: #303133;

      .makeACopyFor-title {}

      .makeACopyFor-num {
        color: #909399;
      }

      .makeACopyFor-box {
        .child-items {
          padding-right: 5px;
          box-sizing: border-box;

          .child-text {
            text-align: center;
          }
        }
      }
    }
  }
}

::v-deep .el-drawer__header {
  color: #000;
  font-size: 18px;
}

::v-deep .el-breadcrumb__separator {
  color: #fff;
}
</style>